var map = {
	"./app-icon.svg": 1693,
	"./caret-right-icon.svg": 1694,
	"./chrome-icon.webp": 1695,
	"./edge-icon.webp": 1696,
	"./firefox-icon.webp": 1697,
	"./opera-icon.webp": 1698,
	"./safari-icon.webp": 1699,
	"./unknown-icon.webp": 1700
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1692;